import 'phaser'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { IMachineData } from '../machines/machinesData'
import { IMonster } from '../monsters/monsters'
import { common } from '../main/common-sidecar'
import { fi32, IFrameInfo } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { ITileDataShip } from '../tiles/tilesDataShip'
import { ITileShip } from '../tiles/tilesShip'

import { IBlueprintData } from '../blueprints/blueprintsData'
import { ICargoType } from '../entities/cargoesData'
import { stacks } from '../entities/stacks-sidecar'
import { stevieCam } from '../engine/stevieCam-sidecar'
import { getTileAtMouse } from '../tiles/tileMapShip'
import { scene } from '../main/scene-sidecar'
import { machinePlacer } from './machinePlacer-sidecar'
import { IMachine, IMachinePart } from '../machines/machines'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'

export interface ICursor extends IEntity {
  x: number
  y: number
  imageCursor: Phaser.GameObjects.Image
  imageSelected: Phaser.GameObjects.Image
  imageWillSelect: Phaser.GameObjects.Image
  imageTile: Phaser.GameObjects.Image
  tileData: ITileDataShip | null
  machineData: IMachineData | null
  cargoType: ICargoType | null

  selectedMachine: IMachine | null
}

const objs: ICursor[] = []

let frames: IFrameInfo[] = [fi32(1, 6, 4), fi32(1, 6, 5), fi32(1, 6, 9)]

let frameTileSelector = fi32(1, 6, 9)
// let frameTileSelectorSpawner = fi32(1, 6, 10)
let frameSelectedMin = fi32(1, 6, 11)
let frameWillSelectMin = fi32(1, 6, 12)
let frameNoTile = fi32(5, 7, 9)

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function create(): ICursor {
  let id = common.createId()

  let imageCursor = spriteMap.createImageFromFrameInfo(
    layers.getLayers().uiOnCam,
    frames[0],
    0,
    0,
  )
  imageCursor.visible = false

  let imageTile = spriteMap.createImageFromFrameInfo(
    layers.getLayers().uiOnCam,
    frames[0],
    0,
    0,
  )
  imageTile.visible = false

  let imageWillSelect = spriteMap.createImageFromFrameInfo(
    layers.getLayers().uiOnCam,
    frameWillSelectMin,
    0,
    0,
  )

  let imageSelected = spriteMap.createImageFromFrameInfo(
    layers.getLayers().uiOnCam,
    frames[1],
    0,
    0,
  )
  let obj: ICursor = {
    eType: 'cursor',
    id,
    x: 0,
    y: 0,
    imageCursor,
    imageSelected,
    imageWillSelect,
    imageTile,
    tileData: null,
    machineData: null,
    cargoType: null,
    isDead: false,
    selectedMachine: null,
  }
  objs.push(obj)
  return obj
}

export function clear(obj: ICursor) {
  obj.imageTile.visible = false
  obj.imageCursor.visible = false
  obj.tileData = null
  obj.machineData = null

  spriteMap.setFrame(obj.imageTile, frameNoTile)
  spriteMap.setFrame(obj.imageCursor, frameNoTile)

  // obj.imageWillSelect.visible = false
  //  obj.imageSelected.visible = false
}

export function setToBlueprint(obj: ICursor, data: IBlueprintData) {
  obj.imageTile.alpha = 0.75
  obj.tileData = null
  obj.machineData = null
  obj.cargoType = null
  spriteMap.setFrame(obj.imageTile, data.frame)
  obj.imageTile.visible = true

  machinePlacer.setToMachineData(null)
}

export function setToTile(obj: ICursor, data: ITileDataShip) {
  obj.imageTile.alpha = 0.75
  obj.tileData = data
  obj.machineData = null
  obj.cargoType = null
  spriteMap.setFrame(obj.imageTile, data.frameInfo)
  obj.imageTile.visible = true

  machinePlacer.setToMachineData(null)
}

export function setToStack(obj: ICursor, cargoType: ICargoType) {
  obj.imageTile.alpha = 0.75
  obj.tileData = null
  obj.machineData = null
  obj.cargoType = cargoType
  spriteMap.setFrame(obj.imageTile, stacks.frame)
  obj.imageTile.visible = true

  machinePlacer.setToMachineData(null)
}

export function setToMachine(obj: ICursor, data: IMachineData) {
  obj.imageTile.alpha = 0.75
  obj.tileData = null
  obj.machineData = data
  spriteMap.setFrame(obj.imageTile, data.frames[0])
  obj.imageTile.visible = true

  machinePlacer.setToMachineData(data)
}

export function getSelectedMachine(obj: ICursor) {
  return obj.selectedMachine
}
export function selectMachine(obj: ICursor, target: IMachine | null) {
  obj.selectedMachine = target
  if (!target) {
    obj.imageSelected.visible = false
  } else {
    spriteMap.setFrame(obj.imageSelected, frameTileSelector)
    obj.imageSelected.x = target.image.x - 2
    obj.imageSelected.y = target.image.y + 2
    obj.imageSelected.visible = true
  }
}

export function setWillSelectToMonster(obj: ICursor, target: IMonster | null) {
  // obj.image.alpha = 0.75
  if (!target) {
    obj.imageWillSelect.visible = false
  } else {
    spriteMap.setFrame(obj.imageWillSelect, frameWillSelectMin)
    obj.imageWillSelect.alpha = 0.75
    obj.imageWillSelect.x = target.image.x
    obj.imageWillSelect.y = target.image.y
    obj.imageWillSelect.visible = true
  }
}

export function setSelectedToMonster(obj: ICursor, target: IMonster | null) {
  // obj.image.alpha = 0.75
  if (!target) {
    obj.imageSelected.visible = false
  } else {
    spriteMap.setFrame(obj.imageSelected, frameSelectedMin)
    obj.imageSelected.alpha = 0.75
    obj.imageSelected.x = target.image.x
    obj.imageSelected.y = target.image.y
    obj.imageSelected.visible = true
  }
}

export function setSelectedToTile(obj: ICursor, target: ITileShip | null) {
  // obj.image.alpha = 0.75
  // console.log('sel')
  if (!target) {
    obj.imageSelected.visible = false
  } else {
    //if (tilesData.isUpStair(target)) {
    spriteMap.setFrame(obj.imageSelected, frameTileSelector)
    //} else {
    //}

    obj.imageSelected.x = target.x - 2
    obj.imageSelected.y = target.y + 2
    obj.imageSelected.visible = true
  }
}

export function setCursorToTile(obj: ICursor, target: ITileShip | null) {
  // obj.image.alpha = 0.75
  // console.log('sel')
  if (!target) {
    obj.imageCursor.visible = false
  } else {
    spriteMap.setFrame(obj.imageCursor, frameTileSelector)

    //spriteMap.setFrame(obj.imageCursor, frameTileSelector)
    obj.imageCursor.alpha = 0.75
    obj.imageCursor.x = target.x - 2
    obj.imageCursor.y = target.y + 2
    obj.imageCursor.visible = true
  }
}

export function hideCursor(obj: ICursor) {
  obj.imageCursor.visible = false
}

export function updateAll() {
  let sc = common.getPhaserScene()

  let cam = stevieCam.get()
  let tm = scene.getContext().mapShip

  objs.forEach((c) => {
    if (tileMapEditor.getMode() !== 'test') {
      c.imageTile.visible = true
      c.imageTile.x = sc.input.mousePointer.x / cam.zoom + cam.camera.scrollX
      c.imageTile.y = sc.input.mousePointer.y / cam.zoom + cam.camera.scrollY

      let t = getTileAtMouse(
        tm,
        sc.input.mousePointer.x,
        sc.input.mousePointer.y,
      )

      // Snap to tiles?
      if (t && t.imageFloor) {
        c.imageTile.x = t.imageFloor.x
        c.imageTile.y = t.imageFloor.y
      }

      if (t && t.imageStructure) {
        c.imageTile.x = t.imageStructure.x
        c.imageTile.y = t.imageStructure.y
      }

      if (tileMapEditor.getMode() === 'draft') {
        spriteMap.setFrame(c.imageTile, frames[0])
      }
    } else {
      c.imageTile.visible = false
    }

    // update(c)
  })
  // entitiesUtils.removeDead(objs, (c) => {
  //   if (c.imageFloor) {
  //     c.imageFloor.destroy()
  //   }
  //   if (c.imageWall) {
  //     c.imageWall.destroy()
  //   }
  //   if (c.imageShadow) {
  //     c.imageShadow.destroy()
  //   }
  // })
}
